import React, { useState, useEffect } from "react";
import queryString from "query-string";
import { useIntl } from "react-intl";
import { Input } from "antd";

import LoadSkeleton from "../../app/generic/loadSkeleton";

import "./index.css";

const { Search } = Input;

function Find({ used, setUsed, onClick, loading }) {
  const intl = useIntl();
  const [consignment, setConsignment] = useState("e");
  useEffect(() => {
    if (!used) {
      const queryValue = queryString.parse(window.location.search).consignment;
      queryValue && onClick(queryValue);
      setConsignment(queryValue);
      setUsed(true);
    } else {
      setConsignment();
    }
  }, [used, setUsed, onClick]);

  return consignment === "e" ? (
    <LoadSkeleton />
  ) : (
    <Search
      allowClear
      enterButton
      loading={loading}
      onSearch={onClick}
      defaultValue={consignment}
      placeholder={intl.formatMessage({
        id: "tracking.placeholder",
        defaultMessage: "zadejte číslo zásilky, číslo kusu nebo referenci",
      })}
    />
  );
}

export default Find;
